import React,{useState} from 'react'
import './modeButton.css'
import sun from "./../../assets/icons/sun.png"
import moon from "./../../assets/icons/moon.png" 
import { useDispatch } from "react-redux"; 
import { AddItemToCart} from './../../redux/action/Actions';

function ModeButton() {
    const[theme,setTheme]=useState(true)
    const dispatch = useDispatch()
    
    const func1 =()=>{setTheme(!theme); setTimeout(()=>{dispatch(AddItemToCart(theme))} ,500)}
  return (
    <div className="mb">
    <button className={theme===false?"mb-button2":"mb-button"}
     onClick={func1}>
    {theme===false?<img src={moon} alt="" id="img1"/>: <img src={sun} alt="" id="img1"/>}
    </button>
    </div>
  )
}

export default ModeButton